import { IApiResponse } from "common//models";
import { API_CONFIG, LOCAL_URL, PRODUCTION, UAT } from "common/config";
import { COMMON_JS } from "common/scripts";
import {
  IArgsUserLogin,
  IArgsCheckLogin,
  IArgsUserLogout,
  IArgsSignup,
  IArgsChangePassword,
  IArgsUserProfile,
  IArgsUserProfiles,
} from "./models";

interface ILogin {
  manageUserProfile: (args: IArgsUserProfile) => Promise<IApiResponse>;
  getUserProfile: (args: IArgsUserProfiles) => Promise<IApiResponse>;
  userLogin: (args: IArgsUserLogin) => Promise<IApiResponse>;
  checkLogin: (args: IArgsUserLogin) => Promise<IApiResponse>;
  userLogout: (args: IArgsUserLogin) => Promise<IApiResponse>;
  signUp: (args: IArgsSignup) => Promise<IApiResponse>;
  changePassword: (args: IArgsChangePassword) => Promise<IApiResponse>;
}

const local = PRODUCTION === "false" && UAT === "false";

export class ApiLogin implements ILogin {
  userLogin = async (args: IArgsUserLogin): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/us/v1/T20QIZYP89R5NMJO";
      if (local) {
        apiUrl = LOCAL_URL + ":8001" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.POST,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  checkLogin = async (
    args: IArgsCheckLogin,
    accessToken = ""
  ): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/us/v1/4YLN3HOZBMEFC762";
      if (local) {
        apiUrl = LOCAL_URL + ":8001" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.POST,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  userLogout = async (
    args: IArgsUserLogout,
    token = ""
  ): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/us/v1/QHDY970ZPKVN8G31";
      if (local) {
        apiUrl = LOCAL_URL + ":8001" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.POST,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getUserProfile = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/us/v1/MOTL6Z40C7FV8RK9";
      if (local) {
        apiUrl = LOCAL_URL + ":8001" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };
  manageUserProfile = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/us/v1/AL069BDQJYUPCI32",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  signUp = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/us/v1/OHVTX46Q830CK1AN",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  changePassword = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/us/v1/Z8Y15BEMIHTVJCR2",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  otpLogin = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/us/v1/429T8332L17880AH",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  verifyOtp = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/us/v1/496G9759V27035OB",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };
}
